var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"lds-dual-ring"})]):_vm._e(),_c(_vm.activeComponent,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }